




































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { faPhoneAlt, faPlus } from '@fortawesome/pro-regular-svg-icons';
import IsiContent from './isi-content.vue';
import IriModal from '~/components/iri-content/iri-modal.vue';
import MagentaText from '~/components/MagentaText.vue';

@Component<Footer>({
    components: {
        'isi-content': IsiContent,
        IriModal,
        MagentaText,
    },
    icons: {
        faPhoneAlt,
        faPlus,
    },
})
export default class Footer extends Vue {
    @Prop()
    public brkPoints!: object;
    @Prop()
    public isExpanded!: boolean;

    isShowDialogue = false;

    toggleModal() {
        this.isShowDialogue = !this.isShowDialogue;
    }

    get isLoginPage() {
        return this.$route.path === '/';
    }
}
